const mEditionBillingAcademySalesRecord = {
  mEditionBillingAcademySalesRecord: {
    alerts: {
      updateSubscription: {
        error: 'Un error ha ocurrido. Verifica que la sucripción este activa.',
        success: 'Se canceló en forma exitosamente la suscripción.',
        successGateway: 'Solicitud de cancelación exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      },

      updateVentasConfirmarPago: {
        error: 'Un error ha ocurrido. Verifica los datos del pago y vuelve a intentarlo.',
        success: 'Se confirmó el pago de forma exitosamente.'
      },

      updateVentasReembolsarPago: {
        error: 'Un error ha ocurrido. Verifica los datos del pago y vuelve a intentarlo.',
        success: 'Se reembolso el pago de forma exitosamente.',
        successGateway: 'Solicitud de reembolso exitosa. Deberás esperar la confirmación de la pasarela de pago.'
      }
    },

    infoLeft: {
      venta: {
        compensa: {
          line1: 'Compensación de',
          line2: 'por cambio de plan',
          line3: 'por cambio de medio de pago'
        },
        cancelDate: 'El cliente tendrá acceso hasta el',
        cupon: {
          line1: 'Se aplicó descuento',
          line2: 'del'
        },
        free: 'Gratis',
        fromDate: 'desde',
        iva: 'Se aplicó impuesto (IVA) del',
        labelState: 'Venta',
        montoParcial: 'Monto Parcial de',
        plan: {
          first: 'A pagar en',
          second: 'de',
          third: 'con'
        },
        projects: 'Los Proyectos incluidos son los siguientes',
        satellites: 'Los Satélites (Droops) incluidos son los siguientes',
        suscripcion: {
          idExterno: 'ID de suscripción en',
          payFirst: 'El primer pago será el',
          payNext: 'El próximo pago será el'
        },
        total: 'Monto total de',
        trial: 'Periodo de prueba de',
        trialPay: {
          first: 'Pago por periodo de prueba de',
          second: 'con'
        }
      },
      title: 'DETALLE DE VENTA'
    },

    infoRight: {
      customer: {
        title: 'CLIENTE'
      },

      paragraph: {
        line1: 'Lo sentimos,',
        line2: 'no puedes',
        line3: 'cancelar',
        line4: 'una suscripción',
        line5: 'que aún no fue',
        line6: 'confirmada.'
      },

      paragraphElse: {
        cancel: 'CANCELAR SUSCRIPCIÓN',
        line1: 'Ten en cuenta que al cancelar la suscripción a tu plan de Vidroop, ',
        line2: 'todos tus alumnos',
        line3: ' dejarán de ver tus formaciones.'
      },

      paragraphElseIf: {
        cancelled: 'Cancelada.',
        line1: 'La suscripción a tu plan fue',
        line2: 'Todos tus alumnos dejaron de ver tus formaciones.',
        line3: 'Podrás acceder hasta el día '
      },

      user: {
        from: 'desde'
      }
    },

    table: {
      title: 'LISTADO DE PAGOS',
      thDate: 'FECHA',
      thState: 'ESTADO',
      thTax: 'IMPUESTO',
      thAmount: 'MONTO',
      thMethod: 'MEDIO',
      thToPay: 'A PAGAR',
      thInvoice: 'COMPROBANTE',
      thAccion: 'ACCIONES'
    },

    tooltips: {
      actions: 'Acciones',
      confirm: 'Confirmar',
      invoice: 'Ver',
      refund: 'Reembolsar'
    }
  }
}

export default mEditionBillingAcademySalesRecord
